var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('singletext',[_vm._v(_vm._s(_vm.textdataqian))]),_c('inputcomp'),_c('singletext',[_vm._v(_vm._s(_vm.textdatahou))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }